import { getBezierPath } from "reactflow";

const EDGE_COLORS = {
  indigo: { accent: "#6366F1", track: "#E0E7FF", glow: "#A5B4FC" },
  blue: { accent: "#3B82F6", track: "#DBEAFE", glow: "#93C5FD" },
  emerald: { accent: "#10B981", track: "#D1FAE5", glow: "#6EE7B7" },
  amber: { accent: "#F59E0B", track: "#FEF3C7", glow: "#FCD34D" },
  rose: { accent: "#F43F5E", track: "#FFE4E6", glow: "#FDA4AF" },
  violet: { accent: "#7C3AED", track: "#EDE9FE", glow: "#C4B5FD" },
  cyan: { accent: "#06B6D4", track: "#CFFAFE", glow: "#67E8F9" },
  gray: { accent: "#6B7280", track: "#F3F4F6", glow: "#D1D5DB" },
};

export { EDGE_COLORS };

export default function AnimatedEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  markerEnd,
  selected,
  label,
  data,
  style,
}) {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });

  // Get color from data or style or default
  const colorKey = data?.color || "indigo";
  const palette = EDGE_COLORS[colorKey] || EDGE_COLORS.indigo;
  const accent = selected ? "#7C3AED" : palette.accent;
  const track = selected ? "#C4B5FD" : palette.track;

  return (
    <>
      {/* Soft glow */}
      <path
        d={edgePath}
        fill="none"
        stroke={accent}
        strokeWidth={selected ? 16 : 10}
        strokeOpacity={0.06}
        style={{ animation: "edgePulse 3s ease-in-out infinite" }}
      />
      {/* Track */}
      <path
        d={edgePath}
        fill="none"
        stroke={track}
        strokeWidth={2.5}
        strokeLinecap="round"
      />
      {/* Traveling dot 1 */}
      <circle r={selected ? 4 : 3} fill={accent} opacity={0.9}>
        <animateMotion dur="2.5s" repeatCount="indefinite" path={edgePath} />
      </circle>
      {/* Traveling dot 2 (delayed) */}
      <circle r={2} fill={accent} opacity={0.5}>
        <animateMotion dur="2.5s" repeatCount="indefinite" path={edgePath} begin="0.8s" />
      </circle>
      {/* Traveling dot 3 */}
      <circle r={1.5} fill={accent} opacity={0.3}>
        <animateMotion dur="2.5s" repeatCount="indefinite" path={edgePath} begin="1.6s" />
      </circle>
      {/* Arrow track */}
      <path
        d={edgePath}
        fill="none"
        stroke={accent}
        strokeWidth={1.5}
        strokeOpacity={0.4}
        strokeLinecap="round"
        markerEnd={markerEnd}
      />
      {/* Label */}
      {label && (
        <g transform={`translate(${labelX}, ${labelY})`}>
          <rect
            x={-((String(label).length * 4.5 + 16) / 2)}
            y={-11}
            width={String(label).length * 4.5 + 16}
            height={22}
            rx={11}
            fill="white"
            stroke={accent}
            strokeWidth={1}
            strokeOpacity={0.3}
          />
          <text
            textAnchor="middle"
            dominantBaseline="central"
            style={{
              fontSize: 10,
              fontWeight: 600,
              fill: accent,
              fontFamily: "system-ui, sans-serif",
            }}
          >
            {label}
          </text>
        </g>
      )}
    </>
  );
}
